import {
	FiUser,
	FiMail,
	FiLock,
	FiCreditCard,
	FiHeart,
	FiBarChart2,
	FiBell,
	FiShoppingBag,
	FiTruck,
	FiMapPin,
	FiBriefcase,
	FiRepeat,
} from "react-icons/fi";
import { Role } from "utils/server-constants/roles";
import { Permission } from "utils/server-constants/permissions";

export const accountSections = [
	{
		path: "/my-account",
		label: "Personal details",
		title: "Personal details",
		group: "Account settings",
		icon: FiUser,
		description: "A little about you. Keep your profile and contact details up to date.",
	},
	{
		path: "/my-account/emails",
		label: "Email address",
		title: "Email address",
		group: "Account settings",
		icon: FiMail,
		description: "Manage the email you use to sign in and hear from us.",
	},
	{
		path: "/my-account/password",
		label: "Password & security",
		title: "Password & security",
		group: "Account settings",
		icon: FiLock,
		description: "Keep your account protected with a password that’s unique to you.",
	},
	{
		path: "/my-account/notification-preferences",
		label: "Notifications",
		title: "Make it your inbox",
		group: "Account settings",
		icon: FiBell,
		description: "Choose the updates you’d like to receive. You’re in control.",
	},
	{
		path: "/my-account/subscriptions",
		label: "Subscription",
		title: "Your subscription",
		group: "Your library",
		icon: FiCreditCard,
		description: "Your plan, reading picks, and renewal details in one place.",
	},
	{
		path: "/my-account/wishlist",
		label: "Wishlist",
		title: "Your next great read",
		group: "Your library",
		icon: FiHeart,
		description: "All the books you’ve saved, ready when you are.",
	},
	{
		path: "/my-account/reading-stats",
		label: "Reading activity",
		title: "Your reading journey",
		group: "Your library",
		icon: FiBarChart2,
		description: "Explore your reading habits and see how your library is growing.",
	},
	{
		path: "/my-account/orders",
		label: "Orders",
		title: "Your orders",
		group: "Orders & delivery",
		icon: FiShoppingBag,
		description: "Find your purchases, payment details, and order updates.",
	},
	{
		path: "/my-account/my-addresses",
		label: "Delivery addresses",
		title: "Delivery addresses",
		group: "Orders & delivery",
		icon: FiMapPin,
		description: "Keep your saved addresses ready for your next book delivery.",
	},
	{
		path: "/my-account/assigned-orders",
		label: "Assigned orders",
		title: "Assigned orders",
		group: "Workspace",
		icon: FiTruck,
		permission: Permission.Courier,
		description: "View your assigned deliveries and manage their progress.",
	},
	{
		path: "/my-account/publisher",
		label: "Publisher details",
		title: "Publisher details",
		group: "Workspace",
		icon: FiBriefcase,
		role: Role.SeniorPublisher,
		description: "Manage your publishing house’s profile and business information.",
	},
	{
		path: "/my-account/institution",
		label: "Create institution",
		title: "Create your institution",
		group: "Workspace",
		icon: FiBriefcase,
		role: Role.Individual,
		description: "Register your school or organization and become its institution admin.",
	},
	{
		path: "/my-account/institution",
		label: "Institution details",
		title: "Institution details",
		group: "Workspace",
		icon: FiBriefcase,
		role: Role.Institution,
		description: "Keep your institution’s information and contact details current.",
	},
	{
		path: "/my-account/auto-deductions",
		label: "Auto deductions",
		title: "Automatic renewals",
		group: "Your library",
		icon: FiRepeat,
		hidden: true,
		description: "Manage automatic subscription renewals from your EcoCash wallet.",
	},
];
